import { AbstractComponent } from "appworks/components/abstract-component";
import { Point } from "appworks/utils/geom/point";
import { DMFLinesComponent } from "components/dmf-lines-component";
import { TGRLinesComponent } from "components/tgr-lines-component";
import { LinesComponentFactory } from "slotworks/components/factories/lines-component-factory";
import { LinesComponentConfig } from "slotworks/components/lines/lines-component";

export class DMFLinesComponentFactory extends LinesComponentFactory {

    constructor(protected lineDefinitions: Point[][], protected config?: LinesComponentConfig) {
        super(lineDefinitions, config);
    }

    public build(): AbstractComponent {
        return new DMFLinesComponent(this.lineDefinitions, this.config);
    }
}
